import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ChevronUpNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M17.2977 14.876C16.9073 15.2691 16.2719 15.2702 15.8802 14.8785L12.0002 10.9985L8.12017 14.8785C7.72845 15.2702 7.093 15.2691 6.70267 14.876C6.31428 14.4849 6.3154 13.8533 6.70517 13.4635L10.5859 9.58274C11.367 8.80169 12.6333 8.80169 13.4144 9.58273L17.2952 13.4635C17.6849 13.8533 17.686 14.4849 17.2977 14.876Z'
            fill='currentColor'
        />
    </svg>
));
